export const prestadoresInfo = [
	{
		title: "Total",
		value: 2.801,
		icon: (
			<svg
				width="66"
				height="34"
				viewBox="0 0 66 34"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M33.1426 18.8906C37.5572 18.8906 41.4572 19.9469 44.6259 21.3281C47.5509 22.6281 49.3926 25.5531 49.3926 28.7219V33.1094H16.8926V28.749C16.8926 25.5531 18.7342 22.6281 21.6592 21.3552C24.828 19.9469 28.728 18.8906 33.1426 18.8906ZM11.4759 19.5677C14.4551 19.5677 16.8926 17.1302 16.8926 14.151C16.8926 11.1719 14.4551 8.73437 11.4759 8.73437C8.49674 8.73437 6.05924 11.1719 6.05924 14.151C6.05924 17.1302 8.49674 19.5677 11.4759 19.5677ZM14.5363 22.5469C13.5342 22.3844 12.5322 22.276 11.4759 22.276C8.79466 22.276 6.24883 22.8448 3.94674 23.8469C1.94258 24.7135 0.642578 26.6635 0.642578 28.8573V33.1094H12.8301V28.749C12.8301 26.501 13.453 24.3885 14.5363 22.5469ZM54.8092 19.5677C57.7884 19.5677 60.2259 17.1302 60.2259 14.151C60.2259 11.1719 57.7884 8.73437 54.8092 8.73437C51.8301 8.73437 49.3926 11.1719 49.3926 14.151C49.3926 17.1302 51.8301 19.5677 54.8092 19.5677ZM65.6426 28.8573C65.6426 26.6635 64.3426 24.7135 62.3384 23.8469C60.0363 22.8448 57.4905 22.276 54.8092 22.276C53.753 22.276 52.7509 22.3844 51.7488 22.5469C52.8322 24.3885 53.4551 26.501 53.4551 28.749V33.1094H65.6426V28.8573ZM33.1426 0.609375C37.6384 0.609375 41.2676 4.23854 41.2676 8.73437C41.2676 13.2302 37.6384 16.8594 33.1426 16.8594C28.6467 16.8594 25.0176 13.2302 25.0176 8.73437C25.0176 4.23854 28.6467 0.609375 33.1426 0.609375Z"
					fill="#4D4D4D"
				/>
			</svg>
		),
	},
];

const br = require("apexcharts/dist/locales/pt-br.json");

const dataAcessosMes = [0, 160, 240, 350, 700, 880, 949, 1050, 1234, 1300];

export const optionsAcessosMes = {
	series: [
		{
			name: "Acessos",
			data: dataAcessosMes,
		},
	],
	chart: {
		locales: [br],
		defaultLocale: "br",
	},
	options: {
		colors: ["#663780"],
		chart: {
			height: 350,
			type: "line",
			zoom: {
				enabled: false,
			},
			fontFamily: "'Lexend'",
			foreColor: "#535353",
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			curve: "straight",
			width: 3,
		},
		title: {
			text: "Número de acessos por mês",
			align: "left",
			style: {
				color: "#1E1E24",
				fontStyle: "normal",
				fontWeight: 400,
				fontSize: "16px",
				lineHeight: "20px",
			},
		},
		grid: {
			row: {
				colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
				opacity: 0.5,
			},
		},
		xaxis: {
			categories: [
				"Jan",
				"Fev",
				"Mar",
				"Abr",
				"Mai",
				"Jun",
				"Jul",
				"Ago",
				"Set",
				"Out",
				"Nov",
				"Dez",
			],
			labels: {
				style: {
					fontStyle: "normal",
					fontWeight: 400,
					fontSize: "12px",
					lineHeight: "15px",
					textAlign: "center",
				},
			},
		},
		yaxis: {
			show: true,
			forceNiceScale: true,
			stepSize: 300,
			labels: {
				style: {
					fontStyle: "normal",
					fontWeight: 400,
					fontSize: "11px",
					lineHeight: "14px",
					textAlign: "right",
				},
			},
		},
	},
};

const dataTitulares = [25, 160, 240, 350, 700, 880, 949, 1050, 1234, 1300];
const dataMediaDependentes = [5, 100, 140, 150, 350, 500, 449, 550, 700, 750];
const dataDependentesCadastrados = [20, 60, 100, 200, 350, 380, 500, 500, 534, 550];

export const optionsPacientes = {
	series: [
		{
			name: "Titulares cadastrados",
			data: dataTitulares,
		},
		{
			name: "Média dependentes",
			data: dataMediaDependentes,
		},
		{
			name: "Dependentes cadastrados",
			data: dataDependentesCadastrados,
		},
	],
	options: {
		colors: ["#663780", "#49B69B", "#EFCA04"],
		chart: {
			height: 350,
			type: "line",
			zoom: {
				enabled: false,
			},
			fontFamily: "'Lexend'",
			foreColor: "#535353",
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			curve: "straight",
			width: 3,
		},
		title: {
			text: "Número de titulares cadastrados",
			align: "left",
			style: {
				color: "#1E1E24",
				fontStyle: "normal",
				fontWeight: 400,
				fontSize: "16px",
				lineHeight: "20px",
			},
		},
		grid: {
			row: {
				colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
				opacity: 0.5,
			},
		},
		xaxis: {
			categories: [
				"Jan",
				"Fev",
				"Mar",
				"Abr",
				"Mai",
				"Jun",
				"Jul",
				"Ago",
				"Set",
				"Out",
				"Nov",
				"Dez",
			],
			labels: {
				style: {
					fontStyle: "normal",
					fontWeight: 400,
					fontSize: "12px",
					lineHeight: "15px",
					textAlign: "center",
				},
			},
		},
		yaxis: {
			show: true,
			forceNiceScale: true,
			stepSize: 300,
			labels: {
				style: {
					fontStyle: "normal",
					fontWeight: 400,
					fontSize: "11px",
					lineHeight: "14px",
					textAlign: "right",
				},
			},
		},
		legend: {
			position: "top",
			horizontalAlign: "right",
			floating: true,
			offsetY: -25,
			offsetX: 50,
			markers: {
				size: 15,
				shape: "line", // circle, square, line, plus, cross
				strokeWidth: 2,
			},
		},
	},
};

export const optionsPrestadores = {
	options: {
		colors: ["#663780"],
		chart: {
			height: 350,
			type: "line",
			zoom: {
				enabled: false,
			},
			fontFamily: "'Lexend'",
			foreColor: "#535353",
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			curve: "straight",
			width: 3,
		},
		title: {
			text: "Número de prestadores cadastrados",
			align: "left",
			style: {
				color: "#1E1E24",
				fontStyle: "normal",
				fontWeight: 400,
				fontSize: "16px",
				lineHeight: "20px",
			},
		},
		grid: {
			row: {
				colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
				opacity: 0.5,
			},
		},
		xaxis: {
			type: "category",
			labels: {
				style: {
					fontStyle: "normal",
					fontWeight: 400,
					fontSize: "12px",
					lineHeight: "15px",
					textAlign: "center",
				},
			},
		},
		yaxis: {
			show: true,
			forceNiceScale: true,
			stepSize: 300,
			labels: {
				style: {
					fontStyle: "normal",
					fontWeight: 400,
					fontSize: "11px",
					lineHeight: "14px",
					textAlign: "right",
				},
			},
		},
	},
};
